// extracted by mini-css-extract-plugin
module.exports = {"background-image":"_2HFG9Fctts","page-main":"_3pBCDOk8zZ","page-footer":"_3EsqXlK_B1","content":"YdKHzkX4HA","reminder":"bfIP_I_tdX"};